module.exports = __webpack_public_path__ + "img/line-active.71345a64.svg";